module.exports = __webpack_public_path__ + "media/images/font/pepsiowners2-compressed220909-89e8d1e75c38337d677bea0a45afce25.woff";